const mod = () => {
  const subscribers = {};
  const send = (event, metadata) => {
    // console.log("Event: State Machine", event, metadata, subscribers);
    Object.values(subscribers).forEach((fxn) => {
      if (fxn != null) fxn(event, metadata);
    });
  };
  return {
    sendSMEvent: (event, metadata) => {
      send(event, metadata);
    },
    subscribe: (name, fxn) => {
      subscribers[name] = fxn;
    },
    unsubscribe: (name) => {
      delete subscribers[name];
    },
  };
};

const Event = mod();
export default Event;
